import * as Bananas from "bananas-commerce-admin";

import { TableRow } from "@mui/material";

import dayjs from "dayjs";

import AdStatusBadge from "@/extensions/mediahouse/components/AdStatusBadge";
import { layoutName } from "@/extensions/obituary/types";

import { ObituaryMediaResponse } from "../../types";

export interface OrderRowProps {
  data: ObituaryMediaResponse;
  showPublicationAbbreviation?: boolean;
  showDeceased?: boolean;
}

export const OrderRow: React.FC<OrderRowProps> = ({
  data,
  showPublicationAbbreviation = true,
  showDeceased = true,
}) => {
  const { navigate } = Bananas.useRouter();

  const onClick = () => {
    navigate("mediahouse.obituaries:detail", {
      params: { obituary_id: data.id },
    });
  };
  return (
    <TableRow hover sx={{ cursor: "pointer" }} onClick={onClick}>
      <Bananas.TableCell>
        <AdStatusBadge status={data.status} sx={{ width: "100%" }} />
      </Bananas.TableCell>
      <Bananas.TableCell>{data.order_reference}</Bananas.TableCell>
      {showPublicationAbbreviation && (
        <Bananas.TableCell>{data.publication.abbreviation}</Bananas.TableCell>
      )}
      <Bananas.TableCell>{data.creator}</Bananas.TableCell>
      <Bananas.TableCell>{layoutName[data.layout_variant]}</Bananas.TableCell>
      {showDeceased && (
        <Bananas.TableCell>
          {data.deceased.first_name} {data.deceased.last_name}
        </Bananas.TableCell>
      )}
      <Bananas.TableCell>
        {data.publication_date == null
          ? "—"
          : dayjs(data.publication_date).format("YYYY-MM-DD")}
      </Bananas.TableCell>
      {/* TODO Cost column */}
    </TableRow>
  );
};
export default OrderRow;
